import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createTheme, ThemeProvider } from '@material-ui/core';
import { BrowserRouter, Switch } from 'react-router-dom';
import SignIn from './pages/SignIn';
import SuccessWidget from './pages/widget/Success'
import PrivateRoute from './auth/PrivateRoute';
import PublicRoute from './auth/PublicRoute';
import Loader from './UI/Loader';
import { setLoading } from '../store/actions/userActions';
import { RootState } from '../store';
import CreateWidget from './pages/widget/Create';
import LitsWidgetDashBoard from './pages/widget/Index'
import EditWidget from './pages/widget/Edit';
import Home from './pages/home/Home';
import SuccessPay from './pages/successpay/SuccessPay';
import LogoutManager from './auth/LogoutManager';

const App: FC = () => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state: RootState) => state.auth);
  const theme = createTheme({
    typography: {
      fontFamily: ["Helvetica"].join(","),
    }
  });

  // Check if user exists
  useEffect(() => {
    dispatch(setLoading(false));
    document.title = "Successware"
  }, [dispatch]);

  if (loading) {
    return <Loader />;
  }
  return (
    <BrowserRouter>    
      <LogoutManager />
      <Switch>
        <PublicRoute path="/" component={SignIn} exact />
        <PublicRoute path="/signin" component={SignIn} exact />
        <PrivateRoute path="/admin/widget/edit" component={EditWidget} exact />
        <PrivateRoute path="/admin/widget/create" component={CreateWidget} exact />
        <PrivateRoute path="/admin/widget/" component={LitsWidgetDashBoard} exact />
        <PrivateRoute path="/admin/widget/success" component={SuccessWidget} exact />
        <ThemeProvider theme={theme}>
          <PrivateRoute path="/admin" component={Home} exact />
          <PrivateRoute path="/admin/successwarepay" component={SuccessPay} exact />
        </ThemeProvider>
      </Switch>
    </BrowserRouter>

  );
}

export default App;
